import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme)=>({
        span: {
            border: 0,
            margin: 0,
            padding: 0,
            fontSize: theme.tokens.typography.variant.body2.fontSize,
            fontWeight: theme.tokens.typography.variant.body2.fontWeight,
            letterSpacing: theme.tokens.typography.variant.body2.letterSpacing,
            lineHeight: theme.tokens.typography.variant.body2.lineHeight,
            whiteSpace: 'pre'
        },
        hidden: {
            visibility: 'hidden',
            position: 'absolute'
        },
        input: {
            border: 0,
            margin: 0,
            padding: 0,
            fontSize: theme.tokens.typography.variant.body2.fontSize,
            fontWeight: theme.tokens.typography.variant.body2.fontWeight,
            letterSpacing: theme.tokens.typography.variant.body2.letterSpacing,
            lineHeight: theme.tokens.typography.variant.body2.lineHeight,
            color: theme.tokens.colors.original.brand.primary,
            caretColor: theme.tokens.colors.original.brand.primary,
            minWidth: 30,
            height: 'auto',
            '&&&::before': {
                border: 0
            },
            '&&&::after': {
                border: 0
            }
        },
        popper: {
            zIndex: 15,
            pointerEvents: 'none'
        },
        container: {
            boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.25)'
        },
        popoverPaper: {
            marginTop: theme.px(theme.tokens.spacing['4']),
            marginLeft: theme.px(-theme.tokens.spacing['16'])
        }
    }));
export { useStyles };
